import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import * as api from 'core/api';
import * as hygge from 'core/hygge';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class HyggeComponent extends Vue {
    filters: hygge.HyggeFilterService | null = null;

    hyggeNames: { [id: string]: string } | undefined = undefined; // Force non-reactive

    hyggiesToFilter: hygge.HyggeFilterModel[] = [];
    hyggiesToView: { [id: string]: api.HyggeDetailsModel } | undefined = undefined; // Force non-reactive
    hyggiesVisibleCount: number = 0;

    resultsPageSize: number = 20;
    resultsVisible: number = this.resultsPageSize;

    view: string = 'loading';

    get hyggiesVisibleCountLabel(): string {
        if (this.filters && this.filters.touched) {
            return i18next.t('numerous_hygge_filtered', <any>{count: this.hyggiesVisibleCount});
        } else {
            return i18next.t('numerous_hygge_found', <any>{count: this.hyggiesVisibleCount});
        }
    }

    get filteredSearchResults(): hygge.HyggeFilterModel[] {
        if (this.hyggiesToFilter && this.filters) {
            const r = this.filters.filter(this.hyggiesToFilter, this.hyggiesToView!);

            this.hyggiesVisibleCount = r;

            return this.hyggiesToFilter.filter(f => {
                return f.visible;
            });
        } else {
            return [];
        }
    }

    get pagedSearchResults(): hygge.HyggeFilterModel[] {
        return this.filteredSearchResults.slice(0, this.resultsVisible);
    }

    mounted() {
        this.loadModel();
    }

    loadModel() {
        this.view = 'loading';

        new api.ContentService().getHygge().then(
            (result: api.HyggeResult) => {
                this.filters = new hygge.HyggeFilterService(result.hyggies);
                this.hyggiesToFilter = [];
                this.hyggiesToView = {};

                result.items.forEach(item => {
                    this.hyggiesToFilter.push({
                        id: item.id,
                        visible: true
                    });
                    this.hyggiesToView![item.id] = item;
                });

                // Load hygge names
                this.hyggeNames = {};

                for (const item in result.hyggies) {
                    if (item in result.hyggies) {
                        if (result.hyggies[item]) {
                            result.hyggies[item].forEach((hygge) => {
                                this.hyggeNames![hygge.id] = hygge.name;
                            });
                        }
                    }
                }

                this.hyggiesVisibleCount = this.hyggiesToFilter.length;

                this.view = 'view';
            },
            (error) => {
                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }

    resetFilters() {
        this.filters!.clear();
    }
}
